var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_participant",
    "data-name": "add participant",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.312,
    height: 14.54,
    viewBox: "0 0 20.312 14.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-person-add",
    "data-name": "Icon ionic-md-person-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_369",
    "data-name": "\\uD328\\uC2A4 369",
    d: "M15.145,11.77A3.635,3.635,0,1,0,11.51,8.135,3.645,3.645,0,0,0,15.145,11.77Zm0,1.817c-2.408,0-7.27,1.227-7.27,3.635V19.04H22.414V17.222C22.414,14.814,17.553,13.587,15.145,13.587Z",
    transform: "translate(-2.102 -4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_370",
    "data-name": "\\uD328\\uC2A4 370",
    d: "M6.9,15.018V11.25H4.974v3.768H1.125V16.9H4.974V20.67H6.9V16.9h3.849V15.018Z",
    transform: "translate(-1.125 -9.056)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.61af42153b8909343d7b3362b506b728.svg";
export { ForwardRef as ReactComponent };